import { translate } from '../../common/translation/translate';
import { defaultText } from './constants';

export const getAirQualityDescription = (airQualityValue: number): string => {
    if (!Number.isInteger(airQualityValue)) {
        return defaultText;
    }
    if (airQualityValue < 20) {
        return translate('excellent');
    }
    if (airQualityValue < 40) {
        return translate('fair');
    }
    if (airQualityValue < 60) {
        return translate('moderate');
    }
    if (airQualityValue < 80) {
        return translate('low');
    }
    return translate('poor');
};